module.exports = __webpack_public_path__ + "img/drug-cat-3.7dafcf45.png";